__webpack_require__.p = "/assets/turbo/679c77e0/quellede/_next/";